module.exports = __webpack_public_path__ + "img/salmon_crudo_assemble.bd4ee3a8.jpg";